import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import {LoginModalContext} from '@adv-mt/mt-context-login-modal'

const BASE_CLASS = 'mt-LoginBanner'
const TEXT_CLASS = `${BASE_CLASS}-text`
const TITLE_CLASS = `${TEXT_CLASS}Title`
const DESCRIPTION_CLASS = `${TEXT_CLASS}Description`
const BUTTONS_CLASS = `${BASE_CLASS}-loginButtons`
const BUTTONS_ITEM_CLASS = `${BASE_CLASS}-loginButtonsItem`
const IMAGE_CLASS = `${BASE_CLASS}-image`

const LoginBanner = ({
  onLogin = () => {},
  modalLoginSource,
  trackingOrigin,
  title,
  description,
  imageSrc,
  loginLess,
  registerLess
}) => {
  const {i18n, domain} = useContext(Context)
  const domainConfig = domain.get('config')
  const {login, register} = domainConfig.get('LOGIN_SCREENSET_ID_MAPPING')

  const {triggerLoginModal} = useContext(LoginModalContext)

  const handleClick = ({initialScreen}) =>
    triggerLoginModal({
      modalProps: {
        initialScreen,
        source: modalLoginSource,
        ...(trackingOrigin && {trackingOrigin}),
        onLogin
      }
    })

  return (
    <div className={BASE_CLASS}>
      {imageSrc && (
        <div className={IMAGE_CLASS}>
          <AtomImage src={imageSrc} alt={title} />
        </div>
      )}
      <div className={TEXT_CLASS}>
        <p className={TITLE_CLASS}>{title}</p>
        <p className={DESCRIPTION_CLASS}>{description}</p>
      </div>
      <div className={BUTTONS_CLASS}>
        {registerLess ? null : (
          <div className={BUTTONS_ITEM_CLASS}>
            <AtomButton
              design={atomButtonDesigns.SOLID}
              onClick={() => handleClick({initialScreen: register})}
              shape={atomButtonShapes.CIRCULAR}
              color="accent"
              fullWidth
            >
              {i18n.t('LOGIN_BANNER.SIGN_UP')}
            </AtomButton>
          </div>
        )}
        {loginLess ? null : (
          <div className={BUTTONS_ITEM_CLASS}>
            <AtomButton
              design={atomButtonDesigns.OUTLINE}
              onClick={() => handleClick({initialScreen: login})}
              shape={atomButtonShapes.CIRCULAR}
              fullWidth
            >
              {i18n.t('LOGIN_BANNER.SIGN_IN')}
            </AtomButton>
          </div>
        )}
      </div>
    </div>
  )
}

LoginBanner.displayName = 'LoginBanner'
LoginBanner.propTypes = {
  imageSrc: PropTypes.string,
  onLogin: PropTypes.func,
  modalLoginSource: PropTypes.string,
  trackingOrigin: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  loginLess: PropTypes.bool,
  registerLess: PropTypes.bool
}

export default LoginBanner
